<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="8">
        <h2>Corporate</h2>
      </v-col>
      <v-col cols="12">
        <corporate-engagement />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CorporateEngagement from "@/components/reporting/blocks/CorporateEngagement";

export default {
  name: "CorpSummary",
  components: {
    CorporateEngagement,
  },
  data() {
    return {};
  },
};
</script>
